export const navLinks = [
  {
    name: "home",
    link: "home",
  },
  {
    name: "about us",
    link: "about",
  },
  {
    name: "contact",
    link: "contact",
  },
  {
    name: "draft preparation",
    link: "draft",
  },
  {
    name: "contract negotiation",
    link: "contract",
  },
  {
    name: "deals and endorsment",
    link: "deals",
  },
  {
    name: "performance analysis research",
    link: "performance",
  },
  {
    name: "career planning",
    link: "career",
  },
  {
    name: "talent marketing",
    link: "marketing",
  },
];
